import { ISearch } from './ISearch.model';

export class MachineProductLine implements ISearch {
  constructor(public id: string, public name: string) {}

  public search(query: string): boolean {
    return this.id == null || this.id.toLowerCase().indexOf(query) !== -1;
  }
}

export class MachineCategory implements ISearch {
  constructor(public id: string, public productLineId: string, public name: string) {}

  public search(query: string): boolean {
    return this.productLineId == null || this.productLineId.toLowerCase().indexOf(query) !== -1;
  }
}

export class MachineModel implements ISearch {
  constructor(public id: string, public categoryId: string, public name: string, public serie: string, public hidden: boolean = false) {}

  public search(query: string): boolean {
    return this.categoryId == null || this.categoryId.toLowerCase().indexOf(query) !== -1;
  }
}
